const MOBILE_BREAKPOINT = 768

export default {
  data() {
    return {
      isMobile: typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT
    }
  },
  computed: {
    paginationLayout() {
      return this.isMobile
        ? 'total, prev, pager, next'
        : 'total, sizes, prev, pager, next, jumper'
    }
  },
  mounted() {
    this._handleResize = () => {
      this.isMobile = window.innerWidth <= MOBILE_BREAKPOINT
    }
    window.addEventListener('resize', this._handleResize)
  },
  beforeDestroy() {
    if (this._handleResize) {
      window.removeEventListener('resize', this._handleResize)
    }
  }
}
